var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class Blackmagic {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '2.7';
        this.numberVideoInputs = 45;
        this.numberVideoOutputs = 16;
        this.timeouts = new Timeouts();
        this.videoOutputs = Array(45).fill(41);
        this.asyncHandlers = [
            {
                name: 'input labels',
                regExp: /INPUT LABELS:$/i,
                callback: (match) => {
                    const resp = ['ACK\n\n'];
                    resp.push(...this.inputLabelsResponse());
                    this.socket.send(resp.join('\n'));
                },
            },
            {
                name: 'output labels',
                regExp: /OUTPUT LABELS:$/i,
                callback: (match) => {
                    const resp = ['ACK\n\n'];
                    resp.push(...this.outputLabelsResponse());
                    this.socket.send(resp.join('\n'));
                },
            },
            {
                name: 'ping',
                regExp: /PING:/i,
                callback: (match) => {
                    this.socket.send(`ACK`);
                },
            },
            {
                name: 'videohub device query',
                regExp: /VIDEOHUB DEVICE:$/i,
                callback: (match) => {
                    const resp = ['ACK\n\n'];
                    resp.push(...this.videoHubResponse());
                    this.socket.send(resp.join('\n'));
                },
            },
            {
                name: 'video matrix set',
                regExp: /VIDEO OUTPUT ROUTING:\n(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const input = parseInt(match[2], 10);
                    const output = parseInt(match[1], 10);
                    this.videoOutputs[output] = input;
                    this.socket.send(`ACK\n\nVIDEO OUTPUT ROUTING:\n${output} ${input}`);
                },
            },
            {
                name: 'video matrix get',
                regExp: /VIDEO OUTPUT ROUTING:$/i,
                callback: (match) => {
                    const resp = ['ACK\n\n'];
                    resp.push(...this.outputRoutingResponse());
                    this.socket.send(resp.join('\n'));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`NAK`);
                },
            },
        ];
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.timeouts.delay(500);
            this.socket.send(this.initialResponse());
        });
    }
    initialResponse() {
        const resp = [];
        resp.push('PROTOCOL PREAMBLE:');
        resp.push(`Version: ${this.firmwareVersion}`);
        resp.push('\n');
        resp.push(...this.videoHubResponse());
        resp.push('\n');
        // Video input labels
        resp.push(...this.inputLabelsResponse());
        resp.push('\n');
        // Video input status
        resp.push(...this.inputStatusResponse());
        resp.push('\n');
        // Output labels
        resp.push(...this.outputLabelsResponse());
        resp.push('\n');
        resp.push('CONFIGURATION:');
        resp.push('Video Mode: 1080p50');
        resp.push('\n');
        // Video output routing
        resp.push(...this.outputRoutingResponse());
        resp.push('\n');
        resp.push('VIDEO OUTPUT LOCKS:');
        for (let i = 1; i <= this.numberVideoOutputs; i++) {
            resp.push(`${i - 1} U`);
        }
        resp.push('\n');
        resp.push('END PRELUDE:');
        return resp.join('\n');
    }
    inputLabelsResponse() {
        const resp = [];
        resp.push('INPUT LABELS:');
        resp.push('0 Black');
        for (let i = 1; i <= 20; i++) {
            resp.push(`${i} Camera ${i}`);
        }
        resp.push('21 Color Bars');
        resp.push('22 Color 1');
        resp.push('23 Color 2');
        resp.push('24 Media Player 1');
        resp.push('25 Media Player 1 Key');
        resp.push('26 Media Player 2');
        resp.push('27 Media Player 2 Key');
        resp.push('28 ME 1 Key 1 Mask');
        resp.push('29 ME 1 Key 2 Mask');
        resp.push('30 ME 1 Key 3 Mask');
        resp.push('31 ME 1 Key 4 Mask');
        resp.push('32 ME 2 Key 1 Mask');
        resp.push('33 ME 2 Key 2 Mask');
        resp.push('34 ME 2 Key 3 Mask');
        resp.push('35 ME 2 Key 4 Mask');
        resp.push('36 DSK 1 Mask');
        resp.push('37 DSK 2 Mask');
        resp.push('38 SuperSource 1');
        resp.push('39 Clean Feed 1');
        resp.push('40 Clean Feed 2');
        resp.push('41 ME 1');
        resp.push('42 ME 1 PVW');
        resp.push('43 ME 2');
        resp.push('44 ME 2 PVW');
        return resp;
    }
    inputStatusResponse() {
        const resp = [];
        resp.push('VIDEO INPUT STATUS:');
        resp.push('0 Internal');
        for (let i = 1; i <= 20; i++) {
            resp.push(`${i} BNC`);
        }
        for (let i = 21; i <= 44; i++) {
            resp.push(`${i} Internal`);
        }
        return resp;
    }
    outputLabelsResponse() {
        const resp = [];
        resp.push('OUTPUT LABELS:');
        for (let i = 1; i <= 12; i++) {
            resp.push(`${i - 1} Output ${i}`);
        }
        resp.push('12 ME 1');
        resp.push('13 ME 1 PVW');
        resp.push('14 ME 2');
        resp.push('15 ME 2 PVW');
        return resp;
    }
    outputRoutingResponse() {
        const resp = [];
        resp.push('VIDEO OUTPUT ROUTING:');
        for (let i = 1; i <= this.numberVideoOutputs; i++) {
            resp.push(`${i - 1} ${this.videoOutputs[i]}`);
        }
        return resp;
    }
    videoHubResponse() {
        const resp = [];
        resp.push('VIDEOHUB DEVICE:');
        resp.push('Device present: true');
        resp.push('Model name: ATEM 2 M / E Constellation HD');
        resp.push('Friendly name: ATEM 2 M / E Constellation HD');
        resp.push('Unique ID: aefad72fc3e345fdb85392e9b6091398');
        resp.push(`Video inputs: ${this.numberVideoInputs}`);
        resp.push(`Video outputs: ${this.numberVideoOutputs}`);
        return resp;
    }
}
Blackmagic.emulatorType = 'socketEmulator';
Blackmagic.key = '-OIGDNOEHC2BNTnhzEjj';
